import { DocumentNode } from 'graphql';
import { useQuery } from '@apollo/react-hooks';
import { QueryHookOptions } from '@apollo/react-hooks/lib/types';
import { PageMetaContext } from '../context/PageMetaContext';
import { useNotNullableContext } from './useNotNullableContext';
import { QueryResult } from '@apollo/react-common';

export default function useFullPageQuery<TQuery>(
  query: DocumentNode,
  options: QueryHookOptions = {},
): QueryResult<TQuery> {
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );
  const result = useQuery<TQuery>(query, {
    ...options,
    variables: {
      type: pageType.toUpperCase(),
      slug: pageShortName,
      preview: isPreview,
      ...options.variables,
    },
    ssr: false, // We do all our server side queries through our base page query
    errorPolicy: 'all',
    skip: typeof window === 'undefined',
  });
  return result;
}
